import { gql } from '@apollo/client';

export const GET_IS_LENSES_TUTORIAL_SHOWN = gql`
  query GetIsLensesTutorialShown {
    user @client {
      isLensesTutorialShown
    }
  }
`;
